





















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import api from "@/getinfo-api/";
import { AxiosError } from "axios";
import LectureVideoCreate from "@/components/lectures/LectureVideoCreate.vue";
import LecturePagesCreate from "@/components/lectures/LecturePagesCreate.vue";
import LectureSlideCreate from "@/components/lectures/LectureSlideCreate.vue";
import LectureCourseSelect from "@/components/lectures/LectureCourseSelect.vue";
import { LectureCreate as ILectureCreate } from "@/api/models/lecture-create";
import { Lecture as ILecture } from "@/api/models/lecture";
import { LecturePageCreate as ILecturePageCreate } from "@/api/models/lecture-page-create";
import { LectureVideoCreate as ILectureVideoCreate } from "@/api/models/lecture-video-create";
import { LectureSlideCreate as ILectureSlideCreate } from "@/api/models/lecture-slide-create";
import { LectureExtraMaterialCreate as ILectureExtraMaterialCreate } from "@/api/models/lecture-extra-material-create";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { CourseLectureCreate as ICourseLectureCreate } from "@/api/models/course-lecture-create";
import { EmployeeListParams } from "@/getinfo-api/employee";
import SelectEntity from "@/components/form/SelectEntity.vue";
import {
  getCurrentUserId,
  isRoot,
  getCurrentCompanyId,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import LectureExtraMaterialCreate from "@/components/lectures/LectureExtraMaterialCreate.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import LectureEntityFormList from "@/components/lectures/LectureEntityFormList.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component({
  components: {
    CSingleSelect,
    CField,
    LectureExtraMaterialCreate,
    LectureSlideCreate,
    LectureCourseSelect,
    LecturePagesCreate,
    LectureVideoCreate,
    SelectEntity,
    CustomButton,
    LectureEntityFormList
  }
})
export default class LectureForm extends Vue {
  hours!: number;
  title: string = "";
  ownerId: string = "";
  description!: string;
  enabled: boolean = true;
  sort!: number;
  selectedCourse: Array<string> = [];
  slides: Array<ILectureSlideCreate> = [];
  lecturePages: Array<ILecturePageCreate> = [];
  videos: Array<ILectureVideoCreate> = [];
  extraMaterial!: ILectureExtraMaterialCreate;
  saveProcess: boolean = false;
  contentManagers!: EmployeesListClass;
  locale: string = "";

  data() {
    return {
      employeeList: undefined,
      payload: undefined,
      extraMaterial: undefined,
      hours: undefined,
      contentManagers: undefined
    };
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  async addPagesToLecture(lectureId: string) {
    if (this.lecturePages.length) {
      await Promise.all(
        this.lecturePages.map(async page => {
          const lecturePage: ILecturePageCreate = {
            body: page.body,
            sort: page.sort
          };
          await api.LecturePageApi.create(lectureId, lecturePage);
        })
      );
    }
  }

  async addExtraMaterialToLecture(lectureId: string) {
    if (this.extraMaterial) {
      await api.LectureExtraMaterialApi.create(lectureId, this.extraMaterial);
    }
  }

  async addVideoToLecture(lectureId: string) {
    if (this.videos.length) {
      await Promise.all(
        this.videos.map(async video => {
          let params: ILectureVideoCreate = {
            body: video.body,
            title: video.title,
            sort: video.sort
          };
          await api.LectureVideoApi.create(lectureId, params);
        })
      );
    }
  }

  async addSlidesToLecture(lectureId: string) {
    if (this.slides?.length) {
      await Promise.all(
        this.slides.map(async slide => {
          let slideImages: Array<string> = [];
          if (slide.images) {
            slide.images.forEach((img: any) => {
              slideImages.push(img.id);
            });
          }

          let params: ILectureSlideCreate = {
            body: slide.body,
            images: slideImages ? slideImages : undefined,
            sort: slide.sort
          };
          await api.LectureSlideApi.create(lectureId, params);
        })
      );
    }
  }

  async addLectureToCourses(_lectureId: string) {
    if (this.selectedCourse?.length) {
      for (const course of this.selectedCourse) {
        const timestamp = new Date().getTime();

        const lectureId: ICourseLectureCreate = {
          lectureId: _lectureId,
          sort: Math.ceil(timestamp / 1000)
        };
        await api.CourseLectureApi.create(course, lectureId);
      }
    }
  }

  async createLecture() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.$store.getters.GET_FORM_IS_INVALID) {
      return;
    }
    if (this.selectedCourse.length > 0) {
      this.saveProcess = true;
      const LectureForm: ILectureCreate = {
        title: this.title,
        companyId: this.selectedCompanyId,
        ownerId: this.ownerId,
        description: this.description,
        enabled: this.enabled,
        locale: this.locale ?? "",
        hours: this.hours
      };
      api.LectureApi.create(LectureForm)
        .then(async (res: { data: ILecture }) => {
          await this.addPagesToLecture(res.data.id);
          await this.addVideoToLecture(res.data.id);
          await this.addSlidesToLecture(res.data.id);
          await this.addExtraMaterialToLecture(res.data.id);
          await this.addLectureToCourses(res.data.id);
          await this.$router.push({
            name: "lecture",
            params: { id: res.data.id }
          });
        })
        .catch(
          (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(error.response.data.message, {
                variant: "danger",
                title: this.$tc(this.$translate.Error)
              });
            }
          }
        )
        .finally(() => {
          this.saveProcess = false;
        });
    } else {
      this.$bvToast.toast(this.$tc(this.$translate.ChooseAtLeastOneCourse), {
        title: this.$tc(this.$translate.Error),
        variant: "danger"
      });
    }
  }

  getSlide(item: Array<ILectureSlideCreate>) {
    this.slides = item;
  }

  getPages(item: Array<ILecturePageCreate>) {
    this.lecturePages = item;
  }

  getVideo(item: Array<ILectureVideoCreate>) {
    this.videos = item;
  }

  createLectureVideo(videos: Array<ILectureVideoCreate>) {
    this.videos = videos;
  }

  addLecturePage(lecturePages: Array<ILecturePageCreate>) {
    this.lecturePages = lecturePages;
  }

  editVideoPage(lectureVideo: Array<ILectureVideoCreate>) {
    this.videos = lectureVideo;
  }

  checkedCourse(selectedCourse: any) {
    this.selectedCourse = selectedCourse;
  }

  createExtraMaterial(item: ILectureExtraMaterialCreate) {
    this.extraMaterial = item;
  }

  getEmployee() {
    let params: EmployeeListParams = {
      id: this.selectedCompanyId,
      roles: ["content_manager"],
      limit: 200
    };
    this.contentManagers = new EmployeesListClass(params);
    this.ownerId = this.root || this.companyOwner ? this.ownerId : this.userId;
  }

  get userId() {
    return getCurrentUserId();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  created() {
    this.getEmployee();
  }

  @Watch("selectedCompanyId")
  updateCompany() {
    this.getEmployee();
  }
}
